<template>
    <div
          class="modal addnew-cusip"
          id="addcusip"
          tabindex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
      <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">ADD TO MY CUSIP </h5>
              <button type="button" class="close" aria-label="Close"  @click="$emit('close')">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
                <div class="container">
                    <div class="row justify-content-center">
                        <div class="col-12 col-md-10 col-lg-8">
                                <div class="card-body row no-gutters align-items-center">
                                    <div class="col">
                                        <input style="padding:9px" maxlength="9" v-model="searchVal" class="form-control form-control-lg form-control-borderless" type="search" placeholder="Search Cusip">
                                    </div>
                                    <!--end of col-->
                                    <div class="col-auto">
                                        <button @click="getCusipList()" class="btn btn-primary rounded-right">Search</button>
                                    </div>
                                    <!--end of col-->
                                </div>
                        </div>
                        <!--end of col-->
                    </div>
                    <div v-if="cusipData" class="row justify-content-center">
                        <div class="col-md-12">
                          <div class="card card-sm">
                             <div class="card-body row text-left">
                                    <div class="col-4">
                                        <span>CUSIP : <b>{{cusipData.cusip}}</b></span>
                                    </div>
                                     <div class="col-4">
                                        <span>Maturity Date : <b>{{cusipData.maturityDate}}</b></span>
                                    </div>
                                     <div class="col-4">
                                        <span>Call Date: <b>{{cusipData.callDate}}</b></span>
                                    </div>
                                    <div  class="col-12 mt-3">
                                        <span>Description: <b>{{cusipData.description}}</b></span>
                             </div> 
                             </div>
                                       
                          </div>
                        </div>
                    </div> 
                </div>
            </div>
            <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
            <p v-if="cusipValidationErrors.length">
                <ul>
                  <li class="alert alert-danger" role="alert" v-for="error in cusipValidationErrors" v-bind:key="error">{{ error }}</li>
                </ul>
              </p>
            <div class="modal-footer bid">
              <button type="button" class="btn btn-secondary" @click="$emit('close')">CANCEL</button>
              <button :disabled="!cusipData" type="button" class="btn btn-primary" @click="addToMyCusip()">ADD TO MY CUSIP</button>
            </div>
          </div>
        </div>
      </div>
</template>
<script>
//import config from "@/config";
import config from "@/config";
import authService from "@/authService";
export default {
  name: "trader-addcusip",
  data() {
    return {
        loading : false,
        searchVal : null,
        cusipData : null,
        cusipValidationErrors : []
    };
  },
  methods: {
    addToMyCusip(){
        this.loading = true;
        const auth = {
          headers: { 'org-token' : authService.getOrgToken() }
        };
        var data = {};
            data.cognito = authService.getUser().cognitoSub;
            data.cusipId = this.cusipData.id
            data.type  = 'BID'
        this.$http
          .post(config.baseUrlBidSide + "/trader-cusip", data, auth)
          .then(() => {
              this.$alert("Cusip added to my cusip list")
             this.loading = false;              
            this.$emit('close');                  
          })
          .catch(e => {
            console.log(e.response);
             this.loading = false;             
          });
    },
    getCusipList() {
        this.cusipValidationErrors = [];
        if (!this.searchVal) {
            this.cusipValidationErrors.push("Cusip number is required.");
            return false;
        }
        if (this.searchVal.length != 9) {
            this.cusipValidationErrors.push("Enter 9 digit characters long  CUSIP");
            return false;
        }
        this.loading = true;
        this.cusipValidationErrors = [];
        const auth = {
            headers: { authorization: this.accessToken ,'org-token' : authService.getOrgToken() }
        };
        this.$http
            .get(
            config.baseUrlBidSide +
                "/cusip/list?page=1&size=10&cusip="+this.searchVal +"&status=ACTIVE,BLOCKED&sortColumn=cusip&sortOrder=ASC&type=BID",
                auth
            )
            .then(result => {
                this.loading = false;
                if(result.data.content.length == 0){
                  this.$alert("No result found","","warning");
                  return false;
                }
                if(result.data.content[0].status  == "BLOCKED"){
                  this.$alert("This CUSIP is blocked","","warning");
                  return false;
                }
                this.cusipData = result.data.content[0];
                
            })
            .catch(e => {
            console.log("Error", e);
            //self.loading = false;
            });
    },
  },
  mounted() {
   
  }
};
</script>